import React, { useState, useEffect } from 'react';
import { useSiteSettings } from '../hooks/useSiteSettings';

const SocialSidebar = () => {
  const { facebookUrl, twitterUrl, instagramUrl, youtubeUrl, tiktokUrl, whatsappUrl, callUrl, snapchatUrl } = useSiteSettings();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (window.location.pathname.startsWith('/admin')) return null;

  const socialLinks = [
    { name: 'Facebook', url: facebookUrl, iconClass: 'fab fa-facebook-f', color: '#1877f3' },
    { name: 'Twitter', url: twitterUrl, iconClass: 'fab fa-x-twitter', color: '#000' },
    { name: 'Instagram', url: instagramUrl, iconClass: 'fab fa-instagram', color: '#e4405f' },
    { name: 'YouTube', url: youtubeUrl, iconClass: 'fab fa-youtube', color: '#ff0000' },
    { name: 'TikTok', url: tiktokUrl, iconClass: 'fab fa-tiktok', color: '#000000' },
    { name: 'WhatsApp', url: whatsappUrl, iconClass: 'fab fa-whatsapp', color: '#25d366' },
    { name: 'اتصال', url: callUrl, iconClass: 'fas fa-phone-alt', color: '#2da44e' },
    { name: 'Snapchat', url: snapchatUrl, iconClass: 'fab fa-snapchat', color: '#fffc00' },
  ].filter(link => link.url && link.url !== '#');

  if (socialLinks.length === 0) return null;

  const iconBoxStyle = {
    display: 'flex',
    alignItems: 'center',
    minWidth: isMobile ? 38 : 56,
    height: isMobile ? 38 : 56,
    borderRadius: isMobile ? 8 : 12,
    background: '#fff',
    boxShadow: '0 2px 12px #e0e0e0',
    fontSize: isMobile ? 18 : 28,
    transition: 'all 0.2s',
    textDecoration: 'none',
    margin: isMobile ? '7px 0' : '14px 0',
    padding: isMobile ? '0 10px 0 4px' : '0 20px 0 10px',
    cursor: 'pointer',
  };

  const iconStyle = {
    minWidth: isMobile ? 20 : 30,
    textAlign: 'center',
    fontSize: isMobile ? 20 : 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const textStyle = {
    marginLeft: isMobile ? 8 : 18,
    fontWeight: 'bold',
    color: '#333',
    fontSize: isMobile ? 12 : 18,
    whiteSpace: 'nowrap',
    lineHeight: '1',
    display: 'flex',
    alignItems: 'center',
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: isMobile ? '20%' : '35%',
        left: 0,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 0,
      }}
    >
      {socialLinks.map((link) => (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          title={link.name}
          style={iconBoxStyle}
          onMouseEnter={e => {
            e.currentTarget.style.boxShadow = '0 4px 16px #bdbdbd';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.boxShadow = iconBoxStyle.boxShadow;
          }}
        >
          <i
            className={link.iconClass + ' fa-2x'}
            style={{
              ...iconStyle,
              color: link.color,
              transition: 'color 0.2s',
            }}
            onMouseEnter={e => (e.currentTarget.style.color = '#fff')}
            onMouseLeave={e => (e.currentTarget.style.color = link.color)}
          ></i>
          <span style={textStyle}>{link.name}</span>
        </a>
      ))}
    </div>
  );
};

export default SocialSidebar;
